import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Down = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="down icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 14.3431L10 4C10 2.89543 10.8954 2 12 2C13.1046 2 14 2.89543 14 4L14 14.3431L17.5858 10.7574C18.3668 9.97631 19.6332 9.97631 20.4142 10.7574C21.1953 11.5384 21.1953 12.8047 20.4142 13.5858L12 22L3.58579 13.5858C2.80474 12.8047 2.80474 11.5384 3.58579 10.7574C4.36683 9.97631 5.63317 9.97631 6.41421 10.7574L10 14.3431Z"
    />
  </svg>
)
